import { useToast } from '@chakra-ui/react';
import { useAuthQuery } from '../../common/apiUtils/queryHelper';
import { contextIdConfig } from '../config';
import { SitecoreContextType } from '../types/types';

const { url, queryKey } = contextIdConfig.get_contextid;
export const useGetSitecoreContextId = ({
  sitecoreContextId,
  enabled = true,
}: {
  sitecoreContextId: string;
  enabled?: boolean;
}) => {
  const isEnabled = enabled && !!sitecoreContextId;
  const toast = useToast();

  return useAuthQuery<SitecoreContextType>(
    queryKey(sitecoreContextId),
    async (axiosInstance) => {
      const response = await axiosInstance?.get(url(sitecoreContextId));
      return response?.data;
    },
    {
      enabled: isEnabled,
      onError: () => {
        toast({
          status: 'error',
          title: `Error fetching Context ID: ${sitecoreContextId}`,
          description: 'Invalid request',
        });
      },
      retry: false,
    },
  );
};
